import { db } from '../config/firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';

export async function updatePlatformLogin(userId: string, platform: 'booking' | 'video', userInfo?: { email?: string; displayName?: string; photoURL?: string; }) {
  const userRef = doc(db, 'users', userId);
  const userDoc = await getDoc(userRef);
  const now = new Date().toISOString();
  if (userDoc.exists()) {
    const userData = userDoc.data();
    const currentLogins = userData.platformLogins || { booking: 0, video: 0 };
    try {
      await updateDoc(userRef, {
        platformLogins: {
          ...currentLogins,
          [platform]: (currentLogins[platform] || 0) + 1
        },
        lastLogin: now
      });
    } catch (error) {
      console.error('Error updating platform login:', error);
    }
  } else {
    // Create user doc with minimal info and lastLogin
    await setDoc(userRef, {
      email: userInfo?.email || '',
      displayName: userInfo?.displayName || '',
      photoURL: userInfo?.photoURL || '',
      platformLogins: { [platform]: 1 },
      lastLogin: now,
      createdAt: now,
      role: 'user'
    }, { merge: true });
  }
} 